import { Project } from "interfaces";

import * as flowConfig from "./config";

export interface ClusteringProject extends Project {
  flow: flowConfig.FLOW_TYPE;
  data_files: { [flowConfig.INPUT_DATA]: string };
}

export const projectIsClusteringAnalysis = (
  project: Project
): project is ClusteringProject => project.flow === flowConfig.FLOW_NAME;
